import { render, staticRenderFns } from "./deleteResource.vue?vue&type=template&id=cad9347a"
import script from "./deleteResource.vue?vue&type=script&lang=js"
export * from "./deleteResource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports